import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getObjectListByPropertyApi } from "api/general";
import { alphabeticSorting } from "app/utils/appHelpers";
import { SUBJECT } from "app/utils/constants/customConstant";

const initialState = {
    data: [],
};

export const getSubjectAPI = createAsyncThunk("getSubjectAPI", async (thunkAPI) => {
    try {

        const res = await getObjectListByPropertyApi(SUBJECT, "state", "1");
        let data = res.data;
        data = alphabeticSorting(data, 'asc');
        return data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }

})



const subject = createSlice({
    name: "subject",
    initialState,
    reducers: {
        setSubjectData: (state, action) => {
            state.data = action.payload;
        },
        getSubjectFetchData: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSubjectAPI.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSubjectAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.data = action.payload;
            })
            .addCase(getSubjectAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.authSubject = null;
            })

    }
});

export const { setSubjectData, getSubjectFetchData } = subject.actions;
export default subject.reducer;